export default "__VITE_ASSET__DTGkpGeH__"